import client from '../../../utils/api'
import { createApiAction } from '../../../utils/redux-tool'

const basePath = '/api/student/:memberId/parent'

export const save = createApiAction('academic/parent/contact-change/update', client.save(basePath))
